import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';

function CollapseWrapper({ children, isCollapse, updateCollapse, openIndex, disable }) {
    if (!isCollapse) {
        return children;
    }
    const handleOpenCollapse = () => {
        if (!disable) {
            updateCollapse(openIndex);
        }
    };
    return (
        <div css={!disable && clickStyle} onClick={handleOpenCollapse}>
            {children}
        </div>
    );
}

CollapseWrapper.propTypes = {
    children: PropTypes.node,
    isCollapse: PropTypes.bool,
    updateCollapse: PropTypes.func,
    openIndex: PropTypes.number,
    disable: PropTypes.bool
};

export default CollapseWrapper;

const clickStyle = css`
    cursor: pointer;
`;
